/* eslint-disable */ /* prettier-ignore */
<template>
  <div class="background-height pb-1 background">
    <b-container fluid>
      <b-row>
        <b-col sm="12" class="">
          <!-- <div class="bg-mobile my-2"></div> -->
          <div class="d-flex justify-content-center">
            <PeopleMobile class="my-2 bg-mobile"></PeopleMobile>
          </div>

          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1715163928/2024/Two-blobs-yellow.gif"
            fluid
            class="blob-mobile"
          ></b-img>
          <div
            class="d-flex justify-content-center align-items-center overflow-hidden zoom-container position-relative"
          >
            <b-img
              src="https://res.cloudinary.com/oredev/image/upload/v1715163928/2024/Two-blobs-yellow.gif"
              fluid
              class="blob-left"
            ></b-img>

            <People class="bg-desktop"></People>
            <b-img
              src="https://res.cloudinary.com/oredev/image/upload/v1715163929/2024/two-blobs.gif"
              fluid
              class="blob-right"
            ></b-img>

            <!--       <b-img
              fluid
              class="p-5 d-none d-sm-block zoom"
              src="https://res.cloudinary.com/oredev/image/upload/v1711569325/2024/landing_page_illustration.png"
              alt=""
            /> -->
            <!--   <svg
              xmlns="http://www.w3.org/2000/svg"
              width="192"
              height="192"
              viewBox="0 0 192 192"
              class="p-5 d-none d-sm-block zoom"
            >
              <path
                fill="#000000"
                d="M192 15v2a11 11 0 0 0-11 11c0 1.94 1.16 4.75 2.53 6.11l2.36 2.36a6.93 6.93 0 0 1 1.22 7.56l-.43.84a8.08 8.08 0 0 1-6.66 4.13H145v35.02a6.1 6.1 0 0 0 3.03 4.87l.84.43c1.58.79 4 .4 5.24-.85l2.36-2.36a12.04 12.04 0 0 1 7.51-3.11 13 13 0 1 1 .02 26 12 12 0 0 1-7.53-3.11l-2.36-2.36a4.93 4.93 0 0 0-5.24-.85l-.84.43a6.1 6.1 0 0 0-3.03 4.87V143h35.02a8.08 8.08 0 0 1 6.66 4.13l.43.84a6.91 6.91 0 0 1-1.22 7.56l-2.36 2.36A10.06 10.06 0 0 0 181 164a11 11 0 0 0 11 11v2a13 13 0 0 1-13-13 12 12 0 0 1 3.11-7.53l2.36-2.36a4.93 4.93 0 0 0 .85-5.24l-.43-.84a6.1 6.1 0 0 0-4.87-3.03H145v35.02a8.08 8.08 0 0 1-4.13 6.66l-.84.43a6.91 6.91 0 0 1-7.56-1.22l-2.36-2.36A10.06 10.06 0 0 0 124 181a11 11 0 0 0-11 11h-2a13 13 0 0 1 13-13c2.47 0 5.79 1.37 7.53 3.11l2.36 2.36a4.94 4.94 0 0 0 5.24.85l.84-.43a6.1 6.1 0 0 0 3.03-4.87V145h-35.02a8.08 8.08 0 0 1-6.66-4.13l-.43-.84a6.91 6.91 0 0 1 1.22-7.56l2.36-2.36A10.06 10.06 0 0 0 107 124a11 11 0 0 0-22 0c0 1.94 1.16 4.75 2.53 6.11l2.36 2.36a6.93 6.93 0 0 1 1.22 7.56l-.43.84a8.08 8.08 0 0 1-6.66 4.13H49v35.02a6.1 6.1 0 0 0 3.03 4.87l.84.43c1.58.79 4 .4 5.24-.85l2.36-2.36a12.04 12.04 0 0 1 7.51-3.11A13 13 0 0 1 81 192h-2a11 11 0 0 0-11-11c-1.94 0-4.75 1.16-6.11 2.53l-2.36 2.36a6.93 6.93 0 0 1-7.56 1.22l-.84-.43a8.08 8.08 0 0 1-4.13-6.66V145H11.98a6.1 6.1 0 0 0-4.87 3.03l-.43.84c-.79 1.58-.4 4 .85 5.24l2.36 2.36a12.04 12.04 0 0 1 3.11 7.51A13 13 0 0 1 0 177v-2a11 11 0 0 0 11-11c0-1.94-1.16-4.75-2.53-6.11l-2.36-2.36a6.93 6.93 0 0 1-1.22-7.56l.43-.84a8.08 8.08 0 0 1 6.66-4.13H47v-35.02a6.1 6.1 0 0 0-3.03-4.87l-.84-.43c-1.59-.8-4-.4-5.24.85l-2.36 2.36A12 12 0 0 1 28 109a13 13 0 1 1 0-26c2.47 0 5.79 1.37 7.53 3.11l2.36 2.36a4.94 4.94 0 0 0 5.24.85l.84-.43A6.1 6.1 0 0 0 47 84.02V49H11.98a8.08 8.08 0 0 1-6.66-4.13l-.43-.84a6.91 6.91 0 0 1 1.22-7.56l2.36-2.36A10.06 10.06 0 0 0 11 28 11 11 0 0 0 0 17v-2a13 13 0 0 1 13 13c0 2.47-1.37 5.79-3.11 7.53l-2.36 2.36a4.94 4.94 0 0 0-.85 5.24l.43.84A6.1 6.1 0 0 0 11.98 47H47V11.98a8.08 8.08 0 0 1 4.13-6.66l.84-.43a6.91 6.91 0 0 1 7.56 1.22l2.36 2.36A10.06 10.06 0 0 0 68 11 11 11 0 0 0 79 0h2a13 13 0 0 1-13 13 12 12 0 0 1-7.53-3.11l-2.36-2.36a4.93 4.93 0 0 0-5.24-.85l-.84.43A6.1 6.1 0 0 0 49 11.98V47h35.02a8.08 8.08 0 0 1 6.66 4.13l.43.84a6.91 6.91 0 0 1-1.22 7.56l-2.36 2.36A10.06 10.06 0 0 0 85 68a11 11 0 0 0 22 0c0-1.94-1.16-4.75-2.53-6.11l-2.36-2.36a6.93 6.93 0 0 1-1.22-7.56l.43-.84a8.08 8.08 0 0 1 6.66-4.13H143V11.98a6.1 6.1 0 0 0-3.03-4.87l-.84-.43c-1.59-.8-4-.4-5.24.85l-2.36 2.36A12 12 0 0 1 124 13a13 13 0 0 1-13-13h2a11 11 0 0 0 11 11c1.94 0 4.75-1.16 6.11-2.53l2.36-2.36a6.93 6.93 0 0 1 7.56-1.22l.84.43a8.08 8.08 0 0 1 4.13 6.66V47h35.02a6.1 6.1 0 0 0 4.87-3.03l.43-.84c.8-1.59.4-4-.85-5.24l-2.36-2.36A12 12 0 0 1 179 28a13 13 0 0 1 13-13zM84.02 143a6.1 6.1 0 0 0 4.87-3.03l.43-.84c.8-1.59.4-4-.85-5.24l-2.36-2.36A12 12 0 0 1 83 124a13 13 0 1 1 26 0c0 2.47-1.37 5.79-3.11 7.53l-2.36 2.36a4.94 4.94 0 0 0-.85 5.24l.43.84a6.1 6.1 0 0 0 4.87 3.03H143v-35.02a8.08 8.08 0 0 1 4.13-6.66l.84-.43a6.91 6.91 0 0 1 7.56 1.22l2.36 2.36A10.06 10.06 0 0 0 164 107a11 11 0 0 0 0-22c-1.94 0-4.75 1.16-6.11 2.53l-2.36 2.36a6.93 6.93 0 0 1-7.56 1.22l-.84-.43a8.08 8.08 0 0 1-4.13-6.66V49h-35.02a6.1 6.1 0 0 0-4.87 3.03l-.43.84c-.79 1.58-.4 4 .85 5.24l2.36 2.36a12.04 12.04 0 0 1 3.11 7.51A13 13 0 1 1 83 68a12 12 0 0 1 3.11-7.53l2.36-2.36a4.93 4.93 0 0 0 .85-5.24l-.43-.84A6.1 6.1 0 0 0 84.02 49H49v35.02a8.08 8.08 0 0 1-4.13 6.66l-.84.43a6.91 6.91 0 0 1-7.56-1.22l-2.36-2.36A10.06 10.06 0 0 0 28 85a11 11 0 0 0 0 22c1.94 0 4.75-1.16 6.11-2.53l2.36-2.36a6.93 6.93 0 0 1 7.56-1.22l.84.43a8.08 8.08 0 0 1 4.13 6.66V143h35.02z"
              ></path>
            </svg> -->

            <!--       <b-img
              style="max-width: 70%"
              class="d-block d-sm-none py-2"
              src="https://res.cloudinary.com/oredev/image/upload/v1712057255/2024/mobile-landing.png"
              alt=""
            /> -->
          </div>
        </b-col>
      </b-row>
      <b-row class="py-4 text-section">
        <b-col cols="12" class="d-flex justify-content-center">
          <b-img
            style="max-width: 70%"
            class="p-3 d-none d-xl-block text-center"
            src="https://res.cloudinary.com/oredev/image/upload/v1713166789/2024/title.png"
          ></b-img>
          <b-img
            fluid
            class="p-3 d-block d-xl-none"
            src="https://res.cloudinary.com/oredev/image/upload/v1713166789/2024/title.png"
          ></b-img>
        </b-col>
        <b-col cols="8" offset="2">
          <!--     <div class="d-flex d-md-none justify-content-center flex-wrap">
            <h1 class="text-center w-100" style="font-size: 2rem">
              6-8TH NOV 2024
            </h1>

     
          </div>
          <div class="d-none d-md-block">
            <h1 class="text-center" style="font-size: 3rem">2024</h1>
            <h2 class="text-center" style="font-size: 1.7rem">6-8TH NOV</h2>
          </div> -->
          <div class="d-flex justify-content-center">
            <router-link to="/tickets">
              <button
                xmlns="http://www.w3.org/1999/xhtml"
                class="btn btn-1 text-center"
              >
                TICKETS
              </button></router-link
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import People from "./Svg/People.vue";
import PeopleMobile from "./Svg/PeopleMobile.vue";

export default {
  components: {
    People,
    PeopleMobile,
  },

  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

.background {
  color: black;
}

.hero-headline {
  width: 100%;
  font-size: 4rem;
  text-transform: uppercase;
  color: #292929;
}

@media screen and (max-width: 900px) {
  .hero-headline {
    font-size: 30px;
  }
}
@media screen and (max-width: 500px) {
  .hero-headline {
    font-size: 20px;
  }
}
.hero-headline-2 {
  width: 100%;
  color: black;
  font-size: 24px;
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-weight: 700;
}

.videoImage {
  width: 60%;
  z-index: 20;
  margin-top: 190px;
}
@media screen and (max-width: 1000px) {
  .videoImage {
    margin-top: 90px;
  }
}
@media screen and (max-width: 600px) {
  .videoImage {
    width: 315px;
  }
}

body {
  background-color: black;
  background-size: 10px 10px;
  height: 100vh;
  overflow: hidden;
  display: flex;
  font-family: "Barlow", sans-serif;
  justify-content: center;
  align-items: center;
}

.text-section {
  background: rgba(239, 237, 234, 1);
}

.zoom {
  animation: zoom-in-zoom-out 3s linear;
  z-index: 99;
  max-height: 75vh;
}
@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(10, 10);
  }
  50% {
    transform: scale(5, 5);
  }
  100% {
    transform: scale(1, 1);
  }
}

.zoom-container {
  min-height: none;
  @media (min-width: 2000px) {
    min-height: 75vh;
  }
}

.blob-right {
  display: none;
  position: absolute;
  width: 5%;
  top: 73%;
  right: 11%;
}
.blob-left {
  display: none;
  position: absolute;
  width: 5%;
  top: 6%;
  left: 11%;
}
.blob-mobile {
  display: block;
  position: absolute;
  width: 32%;
  top: 4%;
  right: 1%;
  bottom: 56%;
}

.bg-mobile {
  display: block;
}

.bg-desktop {
  display: none;
}

@media only screen and (min-width: 600px) {
  .bg-desktop {
    display: block;
  }
  .blob-right {
    display: block;
  }
  .blob-left {
    display: block;
  }
  .blob-mobile {
    display: none;
  }
}

@media only screen and (min-width: 601px) {
  .bg-mobile {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopLandingSection.vue